import $ from 'jquery';

const $slider = $( '.slider' );
const $timeout = $slider.find( '.slides' ).attr( 'data-cycle-timeout' );
const $sliderControls = '<div class="sliderControls sliderControls--prev"><span class="screenReaderText">Previous slide</span></div>'
						+ '<div class="sliderControls sliderControls--next"><span class="screenReaderText">Next slide</span></div>';

function setupSlider() {
	$slider.append( $sliderControls );
}

function initSlider() {
	const opts = {
		slides: '.slide',
		swipe: true,
		timeout: parseInt( $timeout, 10 ),
		speed: 1000,
		prev: '.sliderControls--prev',
		next: '.sliderControls--next',
	};

	$slider.find( 'div.slides' ).cycle( opts );
}

function init() {
	setupSlider();
	initSlider();
}

export default { init };
